module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('Form', {
    ref: "formInline",
    attrs: {
      "model": _vm.formInline,
      "rules": _vm.ruleInline,
      "inline": ""
    }
  }, [_vm._v("\n\tForm\n        "), _c('Form-item', {
    attrs: {
      "prop": "user"
    }
  }, [_c('Input', {
    attrs: {
      "type": "text",
      "placeholder": "Username"
    },
    model: {
      value: (_vm.formInline.user),
      callback: function($$v) {
        _vm.formInline.user = $$v
      },
      expression: "formInline.user"
    }
  }, [_c('Icon', {
    attrs: {
      "type": "ios-person-outline"
    },
    slot: "prepend"
  })], 1)], 1), _vm._v(" "), _c('Form-item', {
    attrs: {
      "prop": "password"
    }
  }, [_c('Input', {
    attrs: {
      "type": "password",
      "placeholder": "Password"
    },
    model: {
      value: (_vm.formInline.password),
      callback: function($$v) {
        _vm.formInline.password = $$v
      },
      expression: "formInline.password"
    }
  }, [_c('Icon', {
    attrs: {
      "type": "ios-locked-outline"
    },
    slot: "prepend"
  })], 1)], 1), _vm._v(" "), _c('Form-item', [_c('Button', {
    attrs: {
      "type": "primary"
    }
  }, [_vm._v("登录")])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-67b1d24d","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/list/iview-ui/Form.vue
// module id = 560
// module chunks = 1